<template>
  <div id="app">
    <header>
      <div>
        <span><i class="fas fa-shopping-cart cart-man"></i>fjarkaup.is</span>
      </div>
    </header>
    <div class="container">
      <main>
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
<style lang="scss">
@import './styles/main.scss';
  .btn-outline-primary {
    color: $primary;
    background-color: transparent;
    background-image: none;
    border-color: $primary;
  }
  .btn-outline-primary:hover {
    color: #fff;
    background-color: $primary;
    border-color: $primary;
  }
  header {
    margin: 0;
    height: 56px;
    padding: 0 16px 0 24px;
    background-color: $primary;
    color: #ffffff;
  }

  header span {
    display: block;
    position: relative;
    font-size: 20px;
    line-height: 1;
    letter-spacing: .02em;
    font-weight: 400;
    box-sizing: border-box;
    padding-top: 16px;
  }

  .cart-man {
    padding-right: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue